import React from 'react'
import _ from 'lodash'
import {
  H4, Div, H5, P,
} from 'konsys-ui'
import {
  Title, TextRowWrapper, SummaryBoxWrapper, Link,
} from './styled'
import { theme } from '../../../styles/_variables'

const TextRow = ({
  data,
  isSummaryInProfile,
  isPredefined,
  isMobileXL,
}) => (
  data.name === 'detail' && isPredefined
    ? <TextRowWrapper display={'block'} isSummaryInProfile={isSummaryInProfile} type={data.name} margin={(data.name === 'detail' && !isPredefined) || data.name === 'detail-technique' ? '16px 0' : '0'}>
        <Div>
          <H5
            style={{
              fontSize: isMobileXL && theme.fonts.size.small,
            }}
            color={(data.name === 'detail' && !isPredefined) ? theme.color.offWhite : data.name === 'detail-technique' ? '#6F6E6E' : '#6F6E6E'}
          >
            {data.title}
          </H5>
        </Div>
        <Div
          padding={isSummaryInProfile ? '8px 0px 8px 0px' : '8px 0px 8px 0px'}
        >
          <Div
            textAlign='left'
            padding={'17px 17px'}
            style={{ border: '0.5px solid #C9C9C9' }}
            bgColor={theme.color.offWhite}
            flexDirection={'row'}
          >
            <P textAlign='right' style={{ wordBreak: 'break-all', fontSize: isMobileXL && theme.fonts.size.small }} color={'#6F6E6E'}>{data.value || '-'}</P>
          </Div>
        </Div>
      </TextRowWrapper>
    : <TextRowWrapper isSummaryInProfile={isSummaryInProfile} type={data.name} margin={(data.name === 'detail' && !isPredefined) || data.name === 'detail-technique' ? '16px 0' : '0'}>
        <Div
          flexBasis={data.name === 'p_id' || isPredefined ? '50%' : '22%'}
          display='flex'
          alignItems='flex-start'
          padding={data.name === 'detail' || data.name === 'detail-technique' ? '4px 24px' : '0'}
          bgColor={data.name === 'detail' ? theme.color.primaryColor : data.name === 'detail-technique' && theme.color.paleGray}
        >
          <H5 style={{ fontSize: isMobileXL && theme.fonts.size.small }} color={data.name === 'detail' ? theme.color.offWhite : data.name === 'detail-technique' ? '#6F6E6E' : '#6F6E6E'}>{data.title}</H5>
        </Div>
        <Div
          flexBasis='77%'
          textAlign='right'
          display='flex'
          alignItems='flex-start'
          justifyContent='flex-end'
          padding={(data.name === 'detail' || data.name === 'detail-technique') ? '8px 24px' : '4px 0px'}
          bgColor={(data.name === 'detail' || data.name === 'detail-technique') && theme.color.offWhite}
          flexDirection={(data.name === 'sampleFiles' || data.name === 'designFiles') ? 'row' : 'row'}
        >
        {
          data.name === 'sampleFiles' || data.name === 'designFiles'
            ? data.value.map((v) => {
              const keyName = data.name === 'sampleFiles' ? 'sampleFileUri' : 'designFileUri'
              if (_.has(v, keyName)) {
                const splitUrl = v[keyName].split('/')
                return <Link
                  color={theme.color.primaryColor}
                  style={{ display: 'inline-block' }}
                  key={v[keyName]}
                  href={v[keyName]}
                  target="_blank" rel="noopener noreferrer"
                  >
                    <P display='block' textAlign='right' margin='0 0 4px'>{splitUrl[splitUrl.length - 1]}</P>
                  </Link>
              }
              return <P style={{ wordBreak: 'break-all', fontSize: isMobileXL && theme.fonts.size.small }} display='block' textAlign='right' key={v} color={theme.color.primaryColor} >{v.name || '-'}</P>
            })
            : <P textAlign='right' style={{ wordBreak: 'break-all', fontSize: isMobileXL && theme.fonts.size.small, lineHeight: (data.name === 'detail' || data.name === 'detail-technique') ? '18px' : '20px' }} color={'#6F6E6E'}>{data.value || '-'}</P>
        }
        </Div>
      </TextRowWrapper>
)

const SummaryBox = ({
  title,
  dataList,
  isSummaryInProfile,
  isPredefined,
  isMobileXL,
}) => (
  <SummaryBoxWrapper isSummaryInProfile={isSummaryInProfile}>
    <Title>
      <H4 color={theme.color.offWhite}>{title}</H4>
    </Title>
    {
      dataList.length > 0
      && <Div padding='24px 0'>
      {
        dataList.map((v) => {
          if (v === null || v.value === null) {
            return null
          }
          return <TextRow isMobileXL={isMobileXL} isSummaryInProfile={isSummaryInProfile} key={v.title} data={v} isPredefined={isPredefined}/>
        })
      }
      </Div>
    }
  </SummaryBoxWrapper>
)

export default SummaryBox



// WEBPACK FOOTER //
// ./src/components/common/summary-detail/index.jsx